import { Scene, geoUtils } from "../base";
import * as THREE from "three";

/* SizeObjects/SizesObjects
 * 寸法表示制御.
 */
class SizeObjects {
    private _objects: THREE.Object3D[];
    private _visible: boolean;
    private _dir: THREE.Vector3;
    private _sign: boolean;
    private _hidden: boolean;
    constructor(dir?: THREE.Vector3, sign?: boolean) {
        this.reset();
        if (dir != undefined) this._dir = dir;
        if (sign != undefined) this._sign = sign;
    }
    public reset(scene?: Scene) {
        if ((scene != undefined) && (this._objects != undefined)) {
            for (let i = 0; i < this._objects.length; i++) {
                if (this._objects[i] == undefined) continue;
                scene.me.remove(this._objects[i]);
                geoUtils.disposeObject(this._objects[i]);
            }
        }
        this._objects = [];
        this._visible = false;
        this._hidden = false;
    }
    public add(obj: THREE.Object3D) {
        obj.visible = this._visible;
        this._objects.push(obj);
    }
    public get visible() { return this._visible; }
    public set visible(vis: boolean) {
        for (let i = 0; i < this._objects.length; i++)
            this._objects[i].visible = vis && !this._hidden;
        this._visible = vis;
    }
    public get hidden() { return this._hidden; }
    public set hidden(hidden: boolean) {
        for (let i = 0; i < this._objects.length; i++)
            this._objects[i].visible = this._visible && !hidden;
        this._hidden = hidden;
    }
    public get objects(): THREE.Object3D[] { return this._objects; }
    public update(lookAt: THREE.Vector3) {
        if (this._dir != undefined) {
            let value: boolean = (Math.abs(this._dir.clone().dot(lookAt)) > 0.71);
            this.hidden = this._sign ? !value : value;
        }
    }
}

/**
 * SizesObjects
 */
export class SizesObjects {
    private _sizesObjects: any = {};
    public get objects(): {} { return this._sizesObjects; }

    private _visible: boolean;
    private _floor: number;
    public get floor() { return this._floor; }
    public set floor(value: number) {
        if (this._visible) {
            for (let key in this.objects) {
                const sizeObjects: SizeObjects = (this.objects as any)[key];
                sizeObjects.visible = (value == 0) || (key.match('L' + value) != null) || (key.match('LXZ' + value) != null) || (key.match('LYZ' + value) != null) || (key.match('V') != null) || (key.match('VXY') != null) || (key.match('VZY') != null);
            }
        }
        else {
            for (let key in this.objects) {
                const sizeObjects: SizeObjects = (this.objects as any)[key];
                sizeObjects.visible = false;
            }
        }
        this._floor = value;
    }

    constructor() {
        this.reset();
    }
    public reset(scene?: Scene) {
        for (let key in this._sizesObjects) {
            this._sizesObjects[key].reset(scene);
        }
        this._sizesObjects = {};
        this._floor = 0;
        this._visible = false;
    }
    public add(label: string, dir?: THREE.Vector3, sign?: boolean) {
        const obj = new THREE.Group();
        const objects: any[] = this._sizesObjects[label];
        if (objects == undefined) {
            this._sizesObjects[label] = new SizeObjects(dir, sign);
        }
        this._sizesObjects[label].add(obj);
    }
    public get visible(): boolean {
        return this._visible;
    }
    public set visible(value: boolean) {
        this._visible = value;
        this.floor = this._floor; // reset visibility
    }
    public setVisible(label: string, visible: boolean) {
        const objects: SizeObjects = this._sizesObjects[label];
        if (objects != undefined) objects.visible = visible;
    }
    public getVisible(label: string): boolean {
        const objects: any[] = this._sizesObjects[label];
        if (objects == undefined) return false;
        return this._sizesObjects[label].visible;
    }
    public getObjects(label: string): THREE.Group[] {
        if (this._sizesObjects[label] != undefined)
            return this._sizesObjects[label].objects;
        return undefined;
    }
    public hasLabel(label: string): boolean {
        const objects: any[] = this._sizesObjects[label];
        return (objects != undefined);
    }
    public update(lookAt: THREE.Vector3) {
        for (let key in this.objects) {
            let sizeObjects: SizeObjects = (this.objects as any)[key];
            sizeObjects.update(lookAt);
        }
    }
}
